<template>
  <div id="siteFrame">
    <initial-input v-if="$store.getters.getUserStatusNumber === 1"/>
    <v-toolbar color="blue-grey" dark fixed app clipped-right>
      <v-toolbar-side-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <router-link to="/home/playlist" class="d-flex ml-3 router-link-active">
        <img src="/static/logo-w.svg" height="40px">
      </router-link>
      <v-spacer></v-spacer>

      <v-dialog
        v-model="dialog"
        persistent
        fullscreen
        transition="dialog-bottom-transition"
      >
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-btn icon @click.native="dialog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>曲検索</v-toolbar-title>
        </v-toolbar>
        <v-btn color="primary" slot="activator" dark block>
          <v-icon left dark>search</v-icon>曲検索
        </v-btn>
        <!--
        <v-btn slot="activator" dark icon>
          <v-icon>search</v-icon>
        </v-btn>
        -->
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-select
                v-model="selectedScenes"
                :items="scene_list"
                item-text="sceneName"
                item-value="id"
                label="シーンを選択"
                chips
                multiple
                clearable
              >
              </v-select>
              <v-select
                v-model="selectedTags"
                :items="tag_list"
                item-text="tagName"
                item-value="id"
                label="タグを選択"
                chips
                clearable
                multiple
              >
              </v-select>
              <v-text-field
                v-model="freeWords"
                label="フリーワード"
                single-line
                clearable
              ></v-text-field>
              <v-checkbox
                v-model="checkPlaylist"
                label="プレイリストに登録済の曲は表示しない"
                class="overflow-visible"
                >
              </v-checkbox>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">キャンセル</v-btn>
            <v-btn color="blue darken-1" flat @click.native="dialog = false" @click="searchTrue()">検索</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-navigation-drawer fixed v-model="drawer" app>
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon medium>supervisor_account</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-2">
                  {{ $store.getters.getGroomFirstName }}様 & {{ $store.getters.getBrideFirstName }}様
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list>
        <stepper/>
        <template v-for="(item, index) in menus">
          <v-list-tile v-if="item.icon" :key="item.title" :to="item.url">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-else-if="item.divider" :key="index"></v-divider>
          <v-subheader v-else-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
        </template>
      </v-list>
      <v-list>
        <v-card-text>
          <v-btn color="primary" dark outline block @click="logout()">
            <v-icon left dark>exit_to_app</v-icon>ログアウト
          </v-btn>
        </v-card-text>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import UserService from '@/components/services/UserService.vue'
import SceneService from '@/components/services/SceneService.vue'
import TagService from '@/components/services/TagService.vue'
import PlayListService from '@/components/services/PlayListService.vue'
import Stepper from '@/components/Stepper.vue'
import InitialInput from '@/components/InitialInput.vue'
import AlertCoverNotLandScape from '@/components/atoms/AlertCoverNotLandScape'
export default {
  name: 'Frame',
  components: {
    AlertCoverNotLandScape,
    Stepper,
    InitialInput
  },
  data () {
    return {
      users: [],
      drawer: null,
      dialog: false,
      scene_list: [],
      tag_list: [],
      selectedScenes: [],
      selectedTags: [],
      freeWords: undefined,
      checkPlaylist: true,
      menus: [
        { title: 'ご利用規約', icon: 'assignment', url: '/home/agreement' },
        { title: 'プライバシーポリシー', icon: 'security', url: '/home/policy' },
        { title: 'よくあるご質問', icon: 'question_answer', url: '/home/faq' },
        { title: 'お問い合わせ', icon: 'contact_mail', url: '/home/contact' },
        { divider: true },
        { header: 'マイページ' },
        { title: 'プレイリスト', icon: 'list', url: '/home/playlist' },
        { title: 'お気に入り', icon: 'favorite', url: '/home/favorite' },
        { title: 'ランキング', icon: 'star', url: '/home/ranking' },
        { title: 'おすすめプレイリスト', icon: 'library_music', url: '/home/recommended' },
        { title: 'お客様情報', icon: 'assignment_ind', url: '/home/info' },
        { title: 'アーティスト', icon: 'mic', url: '/home/artist' }
      ]
    }
  },
  created () {
    this.selectedScenes = this.$store.state.selectedScenes
    this.selectedTags = this.$store.state.selectedTags
    this.freeWords = this.$store.state.freeWords
    this.checkPlaylist = this.$store.state.checkPlaylistFlg
    this.scene_list = SceneService.findAllSearchOption()
    this.tag_list = TagService.findAll()
  },
  methods: {
    /**
     * 曲検索
     **/
    searchTrue () {
      this.$log.debug('methods: searchTrue')
      let sceneIdArray = []
      let tagIdArray = []
      let formData = new URLSearchParams()
      // シーンをパラメータに
      for (let scene in this.selectedScenes) {
        let scenesId = this.selectedScenes[scene]
        formData.append('scene[]', scenesId)
        sceneIdArray.push(scenesId)
      }
      // タグをパラメータに
      for (let tag in this.selectedTags) {
        let tagId = this.selectedTags[tag]
        formData.append('tag[]', tagId)
        tagIdArray.push(tagId)
      }
      // フリーワードをパラメータに
      if (this.freeWords !== undefined) {
        let freewordArray = []
        freewordArray = this.freeWords.replace(/\s+/g, ' ').split(' ')
        for (let i in freewordArray) {
          let word = freewordArray[i]
          formData.append('freeword[]', word)
        }
      }
      // プレイリスト・チェックボックス
      formData.append('playlist', this.checkPlaylist)

      formData.append('offset', 0)
      // FIXME 初期検索結果件数を変更してください
      formData.append('limit', this.$store.state.perSearchCount)
      formData.append('transactionid', this.$store.state.transactionId)
      PlayListService.searchTrue(formData, (response) => {
        this.$log.debug('れす')
        this.$log.debug(response)
        // FIXME 表示用とプレーヤー用を分ける（全件取得して20件ずつ表示）
        this.$store.commit('updateSearchResult', response)
        this.$store.commit('updateStateSelectedScenes', this.selectedScenes)
        this.$store.commit('updateStateSelectedTags', this.selectedTags)
        this.$store.commit('updateStateSelectedSceneIdArray', sceneIdArray)
        this.$store.commit('updateStateSelectedTagIdArray', tagIdArray)
        this.$store.commit('updateStateFreeWords', this.freeWords)
        this.$store.commit('updateStateCheckPlaylistFlg', this.checkPlaylist)
        this.$store.commit('updateStateSearchOffset', 0)
        if (this.$route.name !== 'Search') {
          this.$router.push('/home/search')
        } else {
          location.reload()
        }
      }, (error) => {
        this.$log.debug(error)
      })
    },
    /**
     * ログアウト
     **/
    logout () {
      this.$log.debug('methods: logout')
      let formData = new URLSearchParams()
      formData.append('transactionid', this.$store.state.transactionId)
      UserService.logout(formData, (response) => {
        if (response.success) {
          // ログアウト処理
          this.$store.commit('resetState')
          this.$router.push('/login')
        }
      }, (error) => {
        this.$log.debug(error)
        this.loginErrorFlag = true
      })
    }
  }
}
</script>
<style>
  .input-group label {
    overflow: visible !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Frame.vue